const SPACING_BASE = 0.0625; // 1px in em

export const SPACING_1 = `${SPACING_BASE}em`;
export const SPACING_2 = `${SPACING_BASE * 2}em`;
export const SPACING_4 = `${SPACING_BASE * 4}em`;
export const SPACING_8 = `${SPACING_BASE * 8}em`;
export const SPACING_12 = `${SPACING_BASE * 12}em`;
export const SPACING_16 = `${SPACING_BASE * 16}em`;
export const SPACING_20 = `${SPACING_BASE * 20}em`;
export const SPACING_24 = `${SPACING_BASE * 24}em`;
export const SPACING_28 = `${SPACING_BASE * 28}em`;
export const SPACING_32 = `${SPACING_BASE * 32}em`;
export const SPACING_36 = `${SPACING_BASE * 36}em`;
export const SPACING_40 = `${SPACING_BASE * 40}em`;
export const SPACING_44 = `${SPACING_BASE * 44}em`;
export const SPACING_48 = `${SPACING_BASE * 48}em`;
export const SPACING_52 = `${SPACING_BASE * 52}em`;
export const SPACING_56 = `${SPACING_BASE * 56}em`;
export const SPACING_60 = `${SPACING_BASE * 60}em`;
export const SPACING_64 = `${SPACING_BASE * 64}em`;
export const SPACING_80 = `${SPACING_BASE * 80}em`;
export const SPACING_300 = `${SPACING_BASE * 300}em`;
